/***
 * Created on 2023/7/10
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useState} from 'react';
import UserSettings from "./user_settings";
import Subscription from "./subscription";
import { useTranslation} from 'react-i18next';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {useLanguage} from 'common/Hook';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // default: true
        },
    },
});

function Profile(props) {
    const [tab, setTab] = useState('user_settings');
    const { t, i18n } = useTranslation();
    useLanguage();

    const selectTab = (name) => {
        setTab(name);
    }

    return (
        <QueryClientProvider client={queryClient}>
            <section className="page-wrapper">
                <header className="page-header">{t('@Profile@')}</header>
                <nav className="page-tabbar">
                    <div className="comp-tabbar">
                        <div className="tabbar">
                            <ul>
                                <li className={`tabbar__item cursor-pointer ${tab==='user_settings' ? 'active' : ''}`} onClick={() => selectTab('user_settings')}>{t('@My personal QID account@')}</li>
                                <li className={`tabbar__item cursor-pointer ${tab==='subscription' ? 'active' : ''}`} onClick={() => selectTab('subscription')}>{t('@My Interests@')}</li>
                            </ul>
                        </div>
                    </div>
                </nav>

                <section className="page-body">
                    { tab === 'user_settings' && <UserSettings /> }
                    { tab === 'subscription' && <Subscription /> }
                </section>
            </section>
        </QueryClientProvider>
    );
}

export default Profile;